"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetProductCategoriesByIdsQuery = exports.useGetProductCategoriesQuery = exports.useGetProductsByIdsQuery = exports.useGetProductsQuery = exports.productsApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var base_query_1 = require("./base_query");
// The product service is a separate deployment with its own base URL, so it needs its own api slice.
var productsApi = (0, react_1.createApi)({
    reducerPath: "productsApi",
    baseQuery: (0, base_query_1.authorisedBaseQuery)((_a = process.env.LETS_TRADE_PRODUCT_URL) !== null && _a !== void 0 ? _a : ""),
    refetchOnMountOrArgChange: 30,
    refetchOnFocus: true,
    tagTypes: ["Product", "ProductCategory"],
    endpoints: function (builder) { return ({
        // this service nests each page under content beside its own count, rather than the pagination sibling used elsewhere
        getProducts: builder.query({
            query: function (args) { return ({ url: "v2/product/list", params: args }); },
            transformResponse: function (response) {
                var _a, _b;
                var content = (0, base_query_1.unwrapEnvelope)(response);
                return { items: (_a = content === null || content === void 0 ? void 0 : content.product_list) !== null && _a !== void 0 ? _a : [], count: (_b = content === null || content === void 0 ? void 0 : content.count) !== null && _b !== void 0 ? _b : 0 };
            },
            providesTags: ["Product"],
        }),
        // resolving a saved selection needs the records for those exact ids, which the list endpoint cannot do:
        // it takes a single _id, so a selection outside the loaded page would otherwise be invisible
        getProductsByIds: builder.query({
            query: function (ids) { return ({ url: "v2/filter/products", method: "POST", body: { id_list: ids } }); },
            transformResponse: function (response) { var _a, _b; return (_b = (_a = (0, base_query_1.unwrapEnvelope)(response)) === null || _a === void 0 ? void 0 : _a.product_list) !== null && _b !== void 0 ? _b : []; },
            providesTags: ["Product"],
        }),
        getProductCategories: builder.query({
            query: function (args) { return ({ url: "v2/product/category/list", params: args }); },
            transformResponse: function (response) {
                var _a, _b;
                var content = (0, base_query_1.unwrapEnvelope)(response);
                return { items: (_a = content === null || content === void 0 ? void 0 : content.product_category_list) !== null && _a !== void 0 ? _a : [], count: (_b = content === null || content === void 0 ? void 0 : content.count) !== null && _b !== void 0 ? _b : 0 };
            },
            providesTags: ["ProductCategory"],
        }),
        // the service takes the ids as one comma separated value rather than a repeated parameter
        getProductCategoriesByIds: builder.query({
            query: function (ids) { return ({ url: "v2/product/category/list", params: { category_ids_list: ids.join(",") } }); },
            transformResponse: function (response) { var _a, _b; return (_b = (_a = (0, base_query_1.unwrapEnvelope)(response)) === null || _a === void 0 ? void 0 : _a.product_category_list) !== null && _b !== void 0 ? _b : []; },
            providesTags: ["ProductCategory"],
        }),
    }); },
});
exports.productsApi = productsApi;
var useGetProductsQuery = productsApi.useGetProductsQuery, useGetProductsByIdsQuery = productsApi.useGetProductsByIdsQuery, useGetProductCategoriesQuery = productsApi.useGetProductCategoriesQuery, useGetProductCategoriesByIdsQuery = productsApi.useGetProductCategoriesByIdsQuery;
exports.useGetProductsQuery = useGetProductsQuery;
exports.useGetProductsByIdsQuery = useGetProductsByIdsQuery;
exports.useGetProductCategoriesQuery = useGetProductCategoriesQuery;
exports.useGetProductCategoriesByIdsQuery = useGetProductCategoriesByIdsQuery;
